/*
 * Research product template — scoped behaviour.
 * 1. Research-use confirmation POP-UP: Add to Cart / Buy Now open a modal; the
 *    order proceeds only after the shopper confirms. Confirmation is remembered
 *    for the browsing session (sessionStorage) and recorded as a line-item
 *    property. Everything is scoped to the <product-info> ancestor.
 * 2. Buy Now: adds to cart then continues to checkout (gated).
 * 3. Responsive tabs <-> accordions.
 * 4. Floating / sticky Add to Cart.
 * Initialised once (delegated) so the theme editor never duplicates listeners.
 */
(function () {
  'use strict';

  if (!window.__researchGateInit) {
    window.__researchGateInit = true;

    var SS_KEY = 'nuvoResearchConfirmed';
    function confirmedThisSession() {
      try {
        return sessionStorage.getItem(SS_KEY) === '1';
      } catch (e) {
        return false;
      }
    }
    function rememberConfirmed() {
      try {
        sessionStorage.setItem(SS_KEY, '1');
      } catch (e) {}
    }

    function enableProperty(scope) {
      var prop = scope && scope.querySelector('[data-research-declaration-property]');
      if (prop) prop.removeAttribute('disabled');
    }

    /* ---------- Modal ---------- */
    var pendingAction = null;
    var lastFocused = null;

    function getModal(scope) {
      return scope ? scope.querySelector('[data-research-modal]') : null;
    }

    function openModal(scope) {
      var modal = getModal(scope);
      if (!modal) return false;
      lastFocused = document.activeElement;
      modal.hidden = false;
      void modal.offsetWidth; // reflow so the transition runs
      modal.classList.add('is-open');
      document.documentElement.classList.add('research-modal-open');
      var confirmBtn = modal.querySelector('[data-research-modal-confirm]');
      if (confirmBtn) confirmBtn.focus();
      return true;
    }

    function closeModal(scope) {
      pendingAction = null;
      var modal = getModal(scope);
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('research-modal-open');
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 260);
      if (lastFocused && lastFocused.focus) {
        try {
          lastFocused.focus();
        } catch (e) {}
      }
    }

    // Run `action` immediately if already confirmed this session; otherwise open
    // the modal and defer `action` until the shopper confirms.
    function gate(scope, action) {
      if (confirmedThisSession()) {
        enableProperty(scope);
        action();
        return;
      }
      pendingAction = action;
      openModal(scope);
    }

    /* ---------- Add to Cart (form submit) ---------- */
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target.closest && e.target.closest('form');
        var pf = form && form.closest('product-form.research-form');
        if (!pf) return;
        var scope = pf.closest('product-info');
        if (!getModal(scope)) return; // gate disabled -> allow
        if (confirmedThisSession()) {
          enableProperty(scope);
          return; // allow the native submit through to product-form.js
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        var submitter = e.submitter;
        gate(scope, function () {
          enableProperty(scope);
          if (form.requestSubmit) {
            form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
          } else {
            form.submit();
          }
        });
      },
      true
    );

    /* ---------- Buy Now ---------- */
    function doBuyNow(scope, bn) {
      var pf = scope.querySelector('product-form.research-form');
      var form = pf && pf.querySelector('form');
      if (!form) return;
      enableProperty(scope);
      bn.classList.add('loading');
      var spinner = bn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (d) {
            return { ok: r.ok, d: d };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            bn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            var wrap = pf.querySelector('.product-form__error-message-wrapper');
            if (wrap) {
              wrap.hidden = false;
              var m = wrap.querySelector('.product-form__error-message');
              if (m && res.d && res.d.description) m.textContent = res.d.description;
            }
            return;
          }
          window.location = '/checkout';
        })
        .catch(function () {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        });
    }

    document.addEventListener('click', function (e) {
      var bn = e.target.closest && e.target.closest('[data-research-buynow]');
      if (!bn) return;
      e.preventDefault();
      var scope = bn.closest('product-info');
      if (!getModal(scope)) {
        doBuyNow(scope, bn);
        return;
      }
      gate(scope, function () {
        doBuyNow(scope, bn);
      });
    });

    /* ---------- Modal confirm / close ---------- */
    document.addEventListener('click', function (e) {
      var confirmEl = e.target.closest && e.target.closest('[data-research-modal-confirm]');
      if (confirmEl) {
        var scopeC = confirmEl.closest('product-info');
        rememberConfirmed();
        enableProperty(scopeC);
        var action = pendingAction;
        closeModal(scopeC);
        if (action) action();
        return;
      }
      var closeEl = e.target.closest && e.target.closest('[data-research-modal-close]');
      if (closeEl) {
        closeModal(closeEl.closest('product-info'));
      }
    });

    document.addEventListener('keydown', function (e) {
      var modal = document.querySelector('[data-research-modal].is-open');
      if (!modal) return;
      if (e.key === 'Escape') {
        closeModal(modal.closest('product-info'));
        return;
      }
      if (e.key === 'Tab') {
        var focusable = Array.prototype.filter.call(
          modal.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])'),
          function (el) {
            return !el.disabled && el.offsetParent !== null;
          }
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* ---------- On load: honour a prior session confirmation ---------- */
    function syncConfirmedState() {
      if (!confirmedThisSession()) return;
      Array.prototype.forEach.call(document.querySelectorAll('product-info'), function (scope) {
        enableProperty(scope);
      });
    }
    if (document.readyState !== 'loading') syncConfirmedState();
    else document.addEventListener('DOMContentLoaded', syncConfirmedState);

    /* ---------- Keep the floating bar's variant + price in sync ---------- */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var id = event && event.data && event.data.sectionId;
        if (!id) return;
        var scope = document.getElementById('ResearchProductInfo-' + id);
        if (!scope) return;
        var sticky = scope.querySelector('[data-research-sticky]');
        if (sticky) {
          var v = event.data.variant;
          var sv = sticky.querySelector('[data-research-sticky-variant]');
          if (sv && v && v.title) sv.textContent = v.title;
          var sp = sticky.querySelector('[data-research-sticky-price]');
          var mainPrice = scope.querySelector('#price-' + id);
          if (sp && mainPrice) sp.innerHTML = mainPrice.innerHTML;
        }
        // Recompute the volume-pricing per-unit prices for the new variant.
        var vol = scope.querySelector('[data-research-volume]');
        if (vol && event.data.variant && event.data.variant.price != null) {
          updateVolumePrices(vol, event.data.variant.price);
        }
      });
    }
  }

  /* ------------------------------------------------------------------ *
   * Tabs (desktop) / accordions (mobile)
   * ------------------------------------------------------------------ */
  if (!customElements.get('research-tabs')) {
    class ResearchTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.mql = window.matchMedia('(min-width:' + (this.dataset.breakpoint || 750) + 'px)');
        this._onClick = this.onClick.bind(this);
        this._onKey = this.onKey.bind(this);
        this._sync = this.sync.bind(this);
        this.addEventListener('click', this._onClick);
        this.addEventListener('keydown', this._onKey);
        if (this.mql.addEventListener) this.mql.addEventListener('change', this._sync);
        else if (this.mql.addListener) this.mql.addListener(this._sync);
        this.sync();
      }

      disconnectedCallback() {
        if (this.mql && this.mql.removeEventListener) this.mql.removeEventListener('change', this._sync);
        else if (this.mql && this.mql.removeListener) this.mql.removeListener(this._sync);
      }

      get isDesktop() {
        return this.mql.matches;
      }

      panelFor(tab) {
        return this.querySelector('#' + tab.getAttribute('aria-controls'));
      }

      sync() {
        if (this.isDesktop) {
          var active =
            this.tabs.filter(function (t) {
              return t.getAttribute('aria-selected') === 'true';
            })[0] || this.tabs[0];
          var self = this;
          this.tabs.forEach(function (t) {
            self.setTab(t, t === active, true);
          });
        } else {
          var s = this;
          this.tabs.forEach(function (t) {
            var expanded = t.getAttribute('aria-expanded') === 'true';
            var p = s.panelFor(t);
            if (p) p.hidden = !expanded;
            t.setAttribute('tabindex', '0');
          });
        }
      }

      setTab(tab, active, desktop) {
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('aria-expanded', active ? 'true' : 'false');
        tab.classList.toggle('is-active', active);
        if (desktop) tab.setAttribute('tabindex', active ? '0' : '-1');
        var p = this.panelFor(tab);
        if (p) {
          p.hidden = !active;
          p.classList.toggle('is-active', active);
        }
      }

      onClick(e) {
        var tab = e.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        if (this.isDesktop) {
          var self = this;
          this.tabs.forEach(function (t) {
            self.setTab(t, t === tab, true);
          });
          tab.focus();
        } else {
          var expanded = tab.getAttribute('aria-expanded') === 'true';
          tab.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          tab.setAttribute('aria-selected', expanded ? 'false' : 'true');
          tab.classList.toggle('is-active', !expanded);
          var p = this.panelFor(tab);
          if (p) p.hidden = expanded;
        }
      }

      onKey(e) {
        if (!this.isDesktop) return;
        var idx = this.tabs.indexOf(document.activeElement);
        if (idx === -1) return;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = this.tabs[(idx + 1) % this.tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
        else if (e.key === 'Home') next = this.tabs[0];
        else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (next) {
          e.preventDefault();
          var self = this;
          this.tabs.forEach(function (t) {
            self.setTab(t, t === next, true);
          });
          next.focus();
        }
      }
    }
    customElements.define('research-tabs', ResearchTabs);
  }

  /* ------------------------------------------------------------------ *
   * Floating / sticky Add to Cart
   * ------------------------------------------------------------------ */
  function initStickyAtc() {
    var bars = document.querySelectorAll('product-info [data-research-sticky]');
    Array.prototype.forEach.call(bars, function (sticky) {
      if (sticky.dataset.ioInit) return;
      var scope = sticky.closest('product-info');
      var target = scope && scope.querySelector('.research-form__submit');
      if (!target || !('IntersectionObserver' in window)) return;
      sticky.dataset.ioInit = '1';
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', scrolledPast);
            sticky.setAttribute('aria-hidden', String(!scrolledPast));
          });
        },
        { threshold: 0 }
      );
      io.observe(target);
    });
  }
  if (document.readyState !== 'loading') initStickyAtc();
  else document.addEventListener('DOMContentLoaded', initStickyAtc);
  document.addEventListener('shopify:section:load', initStickyAtc);

  /* ------------------------------------------------------------------ *
   * Volume / multi-buy tiers: highlight the active tier + "you save"
   * hint as the quantity changes. Display only — Shopify applies the £.
   * ------------------------------------------------------------------ */
  function vtFormatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }
  // Recompute each row's per-unit price from a base price (in cents).
  function updateVolumePrices(vol, basePrice) {
    if (!vol || basePrice == null) return;
    var cur = vol.getAttribute('data-currency') || 'GBP';
    vol.setAttribute('data-base-price', basePrice);
    Array.prototype.forEach.call(vol.querySelectorAll('.research-vt'), function (row) {
      var pct = parseFloat(row.dataset.pct) || 0;
      var each = Math.round((basePrice * (100 - pct)) / 100);
      var el = row.querySelector('[data-vt-price]');
      if (el) el.textContent = vtFormatMoney(each, cur);
    });
  }
  function initVolume(root) {
    var blocks = (root || document).querySelectorAll('[data-research-volume]');
    Array.prototype.forEach.call(blocks, function (vol) {
      if (vol.dataset.volInit) return;
      vol.dataset.volInit = '1';
      var scope = vol.closest('product-info') || document;
      var rows = Array.prototype.slice.call(vol.querySelectorAll('.research-vt'));

      function qtyInput() {
        return scope.querySelector('.quantity__input');
      }
      // Select the highest row whose quantity is <= the chosen quantity.
      function selectForQty(q) {
        var chosen = null;
        rows.forEach(function (r) {
          if (q >= (parseInt(r.dataset.qty, 10) || 1)) chosen = r;
        });
        rows.forEach(function (r) {
          r.classList.toggle('is-selected', r === chosen);
        });
      }
      function syncFromInput() {
        var input = qtyInput();
        selectForQty(input ? parseInt(input.value, 10) || 1 : 1);
      }

      rows.forEach(function (row) {
        row.addEventListener('click', function () {
          var input = qtyInput();
          if (input) {
            input.value = row.dataset.qty;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          selectForQty(parseInt(row.dataset.qty, 10) || 1);
        });
      });
      var input = qtyInput();
      if (input) {
        input.addEventListener('change', syncFromInput);
        input.addEventListener('input', syncFromInput);
      }
      syncFromInput();
    });
  }
  if (document.readyState !== 'loading') initVolume();
  else document.addEventListener('DOMContentLoaded', initVolume);
  document.addEventListener('shopify:section:load', function () {
    initVolume();
  });
})();
